(function () {

  function ready() {
    if (document.getElementById('#gdchat-button-seechange').length > 0) {
      const timerId = setInterval(() => {
        if (window.lpTag && window.lpTag.newPage) {
          window.lpTag.newPage(window.location.href);
          clearInterval(timerId);
        }
      }, 1000);
    }
  }

  document.addEventListener('DOMContentLoaded', ready);

}());
